/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Hubs_Signals_Ai_BadgeInputs */

const en_directory_hubs_signals_ai_badge = /** @type {(inputs: Directory_Hubs_Signals_Ai_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-Ready Score`)
};

const zh_directory_hubs_signals_ai_badge = /** @type {(inputs: Directory_Hubs_Signals_Ai_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-Ready Score`)
};

/**
* | output |
* | --- |
* | "AI-Ready Score" |
*
* @param {Directory_Hubs_Signals_Ai_BadgeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_hubs_signals_ai_badge = /** @type {((inputs?: Directory_Hubs_Signals_Ai_BadgeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Hubs_Signals_Ai_BadgeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_hubs_signals_ai_badge(inputs)
	return zh_directory_hubs_signals_ai_badge(inputs)
});
export { directory_hubs_signals_ai_badge as "directory.hubs.signals.ai.badge" }